const overrides = {
  '& .mapbox-improve-map a': {
    fontSize: 12,
  },
  '& .mapboxgl-ctrl-bottom-left': {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  '& .mapboxgl-popup-content': {
    padding: 0,
    borderRadius: '4px',
  },
  '& .mapboxgl-popup-anchor-top .mapboxgl-popup-tip, & .mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip, & .mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip': {
    borderBottomColor: '#3F85EF',
  },
  '& .mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip, & .mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip, & .mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip': {
    borderTopColor: '#3F85EF',
  },
  '& .mapboxgl-popup-anchor-left .mapboxgl-popup-tip': {
    borderRightColor: '#3F85EF',
  },
  '& .mapboxgl-popup-anchor-right .mapboxgl-popup-tip': {
    borderLeftColor: '#3F85EF',
  },
};

export default overrides;
